const constants = {
  EXERCISE_CREATE_LOADING_START: 'EXERCISE_CREATE_LOADING_START',
  EXERCISE_CREATE_LOADING_END: 'EXERCISE_CREATE_LOADING_END',
  EXERCISE_CREATE_SELECT: 'EXERCISE_CREATE_SELECT',
  EXERCISE_CREATE_CHANGE_FORM: 'EXERCISE_CREATE_CHANGE_FORM',
  EXERCISE_CREATE_SELECT_SCENARIO: 'EXERCISE_CREATE_SELECT_SCENARIO',
  EXERCISE_CREATE_SCENARIOS_LIST: 'EXERCISE_CREATE_SCENARIOS_LIST',
  EXERCISE_CREATE_SET_ERROR: 'EXERCISE_CREATE_SET_ERROR',
  EXERCISE_CREATE_CLEAR_ERROR: 'EXERCISE_CREATE_CLEAR_ERROR',
  EXERCISE_CREATE_SUCCESS: 'EXERCISE_CREATE_SUCCESS',
  EXERCISE_CREATE: 'EXERCISE_CREATE',
  EXERCISE_CREATE_CLEAR: 'EXERCISE_CREATE_CLEAR',
};

export default constants;
